// @core/api/endpoints/chat/list_conversations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListConversationsRequest,
  ListConversationsResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List user's conversations
 * Returns a paginated list of all conversations the current user is a member of, sorted by last activity. Includes unread counts and last message preview.
 */
export async function ListConversations(
  params?: PaginatedRequest | ListConversationsRequest,
  options?: RequestOptions
): Promise<ListConversationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/conversations`;
  const requestOptions = options;
  return client.get<ListConversationsResponse>(requestPath, { ...requestOptions, params });
}
